import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import FeedbacksList from '@/components/candidate/FeedbacksList';
import FeedbacksGivenList from '@/components/candidate/FeedbacksGivenList';
import FeedbackRequestsList from '@/components/feedback-requests';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';
import ProjectsTab from '@/components/projects/ProjectsTab';
import CollectiveFeedbacksList from '@/components/feedback/collective/CollectiveFeedbacksList';
import { useRoleMapping } from '@/hooks/useRoleMapping';

const RecruiterTabs = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { isCorporate } = useRoleMapping();
  
  const feedbackContext = 'corporate';
  
  return (
    <Tabs defaultValue="feedbacksGiven" className="w-full">
      <TabsList className={`grid ${isMobile ? 'grid-cols-2 gap-y-2' : isCorporate ? 'grid-cols-5' : 'grid-cols-4'} mb-6 md:mb-8`}>
        <TabsTrigger value="feedbacksGiven" className="text-xs md:text-sm">
          Feedbacks donnés
        </TabsTrigger>
        <TabsTrigger value="feedbacksReceived" className="text-xs md:text-sm">
          Feedbacks reçus
        </TabsTrigger>
        <TabsTrigger value="requests" className="text-xs md:text-sm">
          Demandes
        </TabsTrigger>
        {isCorporate && (
          <TabsTrigger value="collective" className="text-xs md:text-sm">
            Demandes collectives
          </TabsTrigger>
        )}
        <TabsTrigger value="projects" className="text-xs md:text-sm">
          Projets
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="feedbacksGiven">
        <div className="flex justify-end mb-4">
          <Button 
            onClick={() => navigate('/create-feedback')}
            size={isMobile ? "sm" : "default"}
            className="text-xs md:text-sm"
          >
            Nouveau feedback
          </Button>
        </div>
        <FeedbacksGivenList />
      </TabsContent>
      
      <TabsContent value="feedbacksReceived">
        <FeedbacksList />
      </TabsContent>
      
      <TabsContent value="requests">
        <Tabs defaultValue="received" className="w-full">
          <TabsList className="mb-4">
            <TabsTrigger value="received">Reçues</TabsTrigger>
            <TabsTrigger value="sent">Envoyées</TabsTrigger>
          </TabsList>
          <TabsContent value="received">
            <FeedbackRequestsList type="received" context={feedbackContext} />
          </TabsContent>
          <TabsContent value="sent">
            <FeedbackRequestsList type="sent" context={feedbackContext} />
          </TabsContent>
        </Tabs>
      </TabsContent>
      
      {isCorporate && (
        <TabsContent value="collective">
          <CollectiveFeedbacksList />
        </TabsContent>
      )}
      
      <TabsContent value="projects">
        <ProjectsTab />
      </TabsContent>
    </Tabs>
  );
};

export default RecruiterTabs;
